import { openSelectOptions, selectOption, cr_state } from '@/select-box.js';
import $ from 'jquery';
import PriseConstante from '@/views/consultations/prendre-constante'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import DateFilter from '@/components/date-filter';
import store_analyse from '@/store/mods/analyses/analyse'

export default {
    name: 'dashboard-laboratin',
    components: {
        PriseConstante, DateFilter
    },
    props: [],
    data() {
        return {
            vm_state: open_menu_state,
            tvm_state: 0,
            obj:null,
            monthConsultationsLoading: false,
            jr_selected: 'Aujourd\'hui',
            mm_selected: 'Mars',
            consult_month_selected: {
                french: null
            },
            selectedConsultation: null,

            curr_state: cr_state,
            curr_state_02: 0,

            date: new Date(),
            monthsLatest: new Array(),

            drp_menu_class: [],
            r_loading: false,

            salle_is_loading: true,
            salle_is_empty: false,

            renseignement_clinique: '',

            fields: [
                { key: 'numero', label: 'N° bulletin' }, 'patient', { key: 'age', label: 'Âge' }, 'sexe', 'prescripteur',  
                { key: 'analyses', label: 'Analyse.s' }, { key: 'renseignement', label: 'Renseignement clinique' }
            ],
			filter: [],
			perPage: -1,
			currentPage: 1,

            liste_analyse_en_salle: [],

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false
        }
    },

    watch: {
        obj() {
            this.is_disabled = (this.obj != null)?false:true
        },

        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                etat_resultat: 0,
            }
            this.current_date_filter = data
            this.is_month = true
            this.refreshRegistrePrelevement()
        },
    },

    computed: {
        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.current_date.getMonth() + 1; index++) {
                m[index] = this.list_months[index];
            }
            return m;
        },

        countEnAttente() {
            if (this.consultationsEnAttente == null) {
                return 0;
            } else {
                return this.consultationsEnAttente.length;
            }
        },

        monthConsultations() {
            return this.$store.getters['currentMonthConsultationsCount'];
        },

        months() {
            return this.monthsOfYear();
        },

        latestMonthsOfCurrentYear() {
            let index;

            for (index = 0; index < this.date.getMonth() + 1; index++) {
                this.monthsLatest[index] = this.months[index];

            }
            return this.monthsLatest;
        },

        consultationsEnAttente() {
            return this.$store.getters['consultationsEnAttente'];
        },

        countTodayConsultations() {
            return this.$store.getters['todayConsultationsCount']
        },

        currentMonth() {
            return this.latestMonthsOfCurrentYear[this.date.getMonth()];
        },

        get_soins() {
            return this.$store.getters["soins"];
        },
        
        analysesMin(){
            return this.$store.getters['analysesMinimalData'];
        },

        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },

    mounted() {
        const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
            etat_resultat: 0,
        }
        this.current_date_filter = data
        this.is_month = false
        this.refreshRegistrePrelevement()


        // this.curr_month = this.monthOfYear[this.date.getMonth()+1]
        this.$store.commit("SET_TSL_FILTER_DATE", {});

        this.$store.dispatch('getAnalysesMinimalData')
        let t = this;
        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            if (!$clicked.parents().hasClass("option-container")) {
                if (t.vm_state != 0) {
                    t.openMenu(t.vm_state, 'option-box', 'animate-fadeInRight', 'animate-fadeOutRight')
                }
            }

            if (!$clicked.parents().hasClass("option-container")) {
                if (t.tvm_state != 0) {
                    t.openMenu_02(t.tvm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }

            if (!$clicked.parents().hasClass("select-box-o")) {
                if (t.curr_state != 0) {
                    t.openSelectOption(t.curr_state, 'slt-month')
                }
            }

            if (!$clicked.parents().hasClass("select-box")) {
                if (t.curr_state_02 != 0) {
                    t.openSelectOption_02(t.curr_state_02, 'select-opts-c2')
                }
            }
        });

        setTimeout(() => {
            $('.shw1').fadeIn()
        }, 500);

        setTimeout(() => {
            $('.shw2').fadeIn()
        }, 700);

        setTimeout(() => {
            $('.shw3').fadeIn()
        }, 900);

        setTimeout(() => {
            $('.shw4').fadeIn()
        }, 900);

    },

    methods: {
        changeSelectedConsultation: function(consultation) {
            this.selectedConsultation = consultation
        },

        /**
         * Rafraichir la liste d'attente de prelevement
         */
        refreshRegistrePrelevement() {
            this.salle_is_loading = true
            store_analyse.getAnalysesEnSalleAttente(this.current_date_filter).then((liste_analyse_en_salle) => {
                this.liste_analyse_en_salle = liste_analyse_en_salle
                if (this.liste_analyse_en_salle.length > 0) {
                    this.salle_is_empty = false 
                } else {
                    this.salle_is_empty = true
                }
                this.salle_is_loading = false
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                etat_resultat: 0,
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.refreshRegistrePrelevement()
        },

        viewRenseignement(d) {
            this.renseignement_clinique = d.renseignement_clinique
        },

        monthsOfYear: function() {

            var month = new Array()
            month = [{
                    "french": "Janvier",
                    "english": "January"
                },
                {
                    "french": "Février",
                    "english": "February",
                },
                {
                    "french": "Mars",
                    "english": "March",
                },
                {
                    "french": "Avril",
                    "english": "April",
                },
                {
                    "french": "Mai",
                    "english": "May",
                },
                {
                    "french": "Juin",
                    "english": "May",
                },
                {
                    "french": "Juillet",
                    "english": "July",
                },
                {
                    "french": "Aout",
                    "english": "August",
                },
                {
                    "french": "Septembre",
                    "english": "September",
                },
                {
                    "french": "Octobre",
                    "english": "October",
                },
                {
                    "french": "Novembre",
                    "english": "November",
                },
                {
                    "french": "Decembre",
                    "english": "December",
                },
            ]

            return month
        },

        /**
         * Show select options in dropdown
         * @param {int} j_state 
         * @param {string} selector 
         */
        async openSelectOption(j_state, selector) {
            this.curr_state = openSelectOptions.openSelectOption(j_state, selector)
        },

        /**
         * Show select options in dropdown
         * @param {int} j_state 
         * @param {string} selector 
         */
        async openSelectOption_02(j_state, selector) {
            this.curr_state_02 = openSelectOptions.openSelectOption(j_state, selector)
        },

        /**
         * Select option in dropdown
         * @param {string} selected_value
         * @param {string} selected_id 
         * @param {string} selector 
         * @param {string} model_selector 
         */
        async selectOption(selected_value, selected_id, selector, model_selector) {
            this.curr_state = selectOption.chooseOption(selected_id, selector)

            switch (model_selector) {
                case 'jr':
                    this.jr_selected = selected_value;
                    break;
                case 'mm':
                    this.mm_selected = selected_value;
                    break;
                case 'cm':
                    this.consult_month_selected = selected_value;
                    this.monthConsultationsLoading = true
                    this.$store.dispatch('getCountMonthConsultations', { month: this.consult_month_selected.english }).then(
                        () => {
                            this.monthConsultationsLoading = false
                        }
                    )
            }
            console.log(selected_id); //  Recuperer ici l'ID de l'option choisi
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu_02(state, selector, show_in, show_out) {
            this.tvm_state = openMenu.dropMenu(state, selector, show_in, show_out)
            if (state == 0) {
                this.tvm_state = 1
            } else {
                this.tvm_state = 0
            }
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu_02(selector, show_in, show_out) {
            this.tvm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        /**
         * 
         * @param {*} route 
         */
        routeTo(route) {
            this.$router.push({ path: '/analyses/' + route })
        },

        redirectTo(){
            this.$store.commit("SET_TSL_FILTER_DATE", this.current_date_filter);

            this.r_loading = true
            this.$router.push({path:'analyses/registre-others/'+this.obj.id})
        },
    }
}